module.exports = "https://trybtryb-legacy.web.app/img/calypso.a12c583e.webp";